import type SearchTableQuery from '../store/schema/SearchTableQuery';
import { mutatorAction } from 'satcheljs';

// Updates the pagination counts on a search table query after a page of server results is processed.
const updateSearchTableLoadedRowCountsMutator: (
    searchTableQuery: SearchTableQuery,
    isFirstPage: boolean,
    lastIndexFetched: number,
    rowCount: number,
    hasClientSortedResults?: boolean
) => void = mutatorAction(
    'updateSearchTableLoadedRowCounts',
    (
        searchTableQuery: SearchTableQuery,
        isFirstPage: boolean,
        lastIndexFetched: number,
        rowCount: number,
        hasClientSortedResults: boolean = false
    ) => {
        if (isFirstPage) {
            searchTableQuery.hasClientSortedResults = hasClientSortedResults;
            searchTableQuery.lastIndexFetched = lastIndexFetched;
            // Start of a fresh result set: reset to the current page's row count.
            searchTableQuery.maxRowsLoadedFromServer = rowCount;
        } else {
            // Accumulate the server-returned row count so the next-page offset stays aligned to a
            // valid page boundary even when rows are later removed from the table (removals shrink
            // the live row count but must not shrink the pagination offset).
            searchTableQuery.maxRowsLoadedFromServer =
                (searchTableQuery.maxRowsLoadedFromServer ?? 0) + rowCount;
        }
    }
);

export default updateSearchTableLoadedRowCountsMutator;
